(function () {
  taskManagementService.$inject = ["apiService"];
  angular.module('tasks').service('taskManagementService', taskManagementService);

  function taskManagementService(apiService) {
    var _this = this;
    this.getTasks = function (options) {
      var url = 'task';
      if (options) {
        url +=
          '?status=' + options.status + '&limit=' + options.limit + '&offset=' + options.offset;
      }
      return apiService.getSome(url);
    };
    this.adminsList;
    this.getUsersMentioned = function (comment, mentionsArr) {
      var mentions = comment.match(/\B@[a-z0-9_-]+/gi);
      if (!mentions) {
        return;
      }
      var mentionIds = [];
      mentions.forEach(function (mention) {
        var mentionFound = _.find(mentionsArr, function (m) {
          return m.label === mention.slice(1);
        });
        if (mentionFound) {
          mentionIds = mentionIds.concat(mentionFound.ids);
        }
      });
      // eslint-disable-next-line consistent-return
      return _.uniq(mentionIds);
    };
    this.getTransactionDescription = function (id) {
      return apiService.getSome('/service/transaction/' + id + '/description/tms');
    };
    this.getMentions = function (managers, cardMembers) {
      return this.adminsList.map(function (admin) {
        var label = (admin.firstName || '') + (admin.lastName || '');
        return { label: label, ids: [admin.id] };
      })
        .filter(function (admin) {
          return admin.label !== '';
        })
        .concat([
          { label: 'card', ids: _.map(cardMembers, 'id') },
          { label: 'everyone', ids: _.map(this.adminsList, 'id') },
          { label: 'account-manager', ids: [managers.accountManagerId] },
          { label: 'supervisor', ids: [managers.supervisorId] },
          { label: 'data-entry', ids: [managers.dataEntryId] },
          { label: 'transactions', ids: [managers.transactionsId] },
          { label: 'payables', ids: [managers.payablesId] },
          { label: 'payroll', ids: [managers.payrollId] }
        ]);
    };
    this.getAdminsList = function () {
      return apiService.getSome('admins').then(function (response) {
        var admins = response.data;
        // eslint-disable-next-line array-callback-return
        admins.map(function (admin) {
          admin.fullName = admin.firstName + ' ' + admin.lastName;
        });
        _this.adminsList = admins;
      });
    };
    this.getTeams = function () {
      return apiService.getSome('taskteams').then(function (response) {
        var teams = response.data;
        _this.teams = teams;
      });
    };
    this.refreshTask = function (taskId) {
      return apiService.getSome('/task/' + taskId + '/refresh');
    };
    this.getStoreTeamAndPlans = function (storeId) {
      return apiService.getSome('/tms/store/' + storeId + '/with/users');
    };
    this.updateTaskItem = function (item) {
      return apiService.updateSome('taskitem/' + item.id, item);
    };
    this.udpateTask = function (item) {
      return apiService.updateSome('task/' + item.id, item);
    };
    this.sequenceUpdate = function (request) {
      return apiService.postSome('task/bulk', request);
    };
    this.addComment = function (comment, taskId, isDisabled, mentionedUsers) {
      return apiService.postSome('taskcomment', {
        comment: comment,
        isDisabled: isDisabled,
        task: {
          id: taskId
        }
      })
      .then(function (data) {
        if (mentionedUsers) {
          _this.addNotification(mentionedUsers, data.data.id);
        }
        return data.data;
      });
    };
    this.addNotification = function (mentionedUsers, taskCommentId) {
      return apiService.postSome('notification', {
        mentionedUserIds: mentionedUsers,
        taskCommentId: taskCommentId
      });
    };
    this.removeNotification = function (mentionedUsers, taskCommentId) {
      return apiService.postSome('/notification/mention/delete', {
        removedMentionedUserIds: mentionedUsers,
        taskCommentId: taskCommentId
      });
    };
    this.updateComment = function (comment, commentId, mentionedUsers, oldMentions) {
      return apiService.updateSome('taskcomment/' + commentId, {
        comment: comment
      })
      .then(function (data) {
        if (!oldMentions) {
          if (mentionedUsers) {
            _this.addNotification(mentionedUsers, data.data.id);
          }
          return data.data;
        } else if (oldMentions && oldMentions.length > 0) {
          var mentionsDiffUpdate = _.difference(mentionedUsers, oldMentions);
          var mentionsDiffRemove = _.difference(oldMentions, mentionedUsers);
          if (mentionsDiffUpdate) {
            _this.addNotification(mentionsDiffUpdate, data.data.id);
            _this.removeNotification(mentionsDiffRemove, data.data.id);
          }
          return data.data;
        }
      });
    };
    this.deleteComment = function (commentId) {
      return apiService.deleteSome('taskcomment/' + commentId);
    };
    this.addMemberToCard = function (userId, taskId) {
      return apiService.postSome('taskmember', {
        user: {
          id: userId
        },
        task: {
          id: taskId
        }
      });
    };
    this.removeUserFromCard = function (userId, taskId) {
      return apiService.deleteSome('task/' + taskId + '/user/' + userId);
    };
    this.getAllStores = function () {
      return apiService.getSome('admin/stores');
    };
    // this.success = $alert({
    //   title: ' ',
    //   content: 'Update successful',
    //   type: 'success',
    //   show: false,
    //   dismissable: false,
    //   duration: 5
    // });
    //
    // this.error = function (message) {
    //   var errorMessage = message || '';
    //   return $alert({
    //     title: 'Error!',
    //     content: errorMessage,
    //     placement: 'top',
    //     type: 'danger mod-middle',
    //     show: true,
    //     dismissable: true
    //   });
    // };
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/taskManagement/service.js